export default {
    chamados: [],
    conversa: [],
    app_id: '5c45fd41bf48b3021dde75ab',
    dash_id: '5bd344212c903c021d1ebc96',
    grupos: [],
    grupoagentes: [],
    taxistas: [],
    agentes: [],
    grupo_agentes: '',
	grupo_taxistas: '',
}



// WEBPACK FOOTER //
// ./src/store/modules/pxtalk/state.js